

type Bank = {
  index: number
  code: string
  name: string
  swift: string
}

type CountryConfig ={
    LengthRIB?:number | { min: number; max: number }
    LengthCIN?:number
    lengthPhone:number
    lengthCodeIBAN?:number
    CodeIBAN?: string
    banks?:Bank[]

}
 
  export const LISTBANCAIRE: Record<string, CountryConfig> = {
    TUN:{
        LengthRIB:20,
        LengthCIN:8,
        lengthPhone:8,
        CodeIBAN:'TN59',
        lengthCodeIBAN:2,
        banks:[
          { index: 0, code: '08', name: 'BIAT', swift: 'BIATTNTT' },
          { index: 1, code: '03', name: 'BNA', swift: 'BNTETNTTSSE' },
          { index: 2, code: '10', name: 'STB', swift: 'STBKTNTTXXX' },
          { index: 3, code: '14', name: 'BH', swift: 'BHBKTNTT' },
          { index: 4, code: '04', name: 'Attijari', swift: 'BSTUTNTTXXX' },
          { index: 5, code: '07', name: 'Amen', swift: 'CFCTTNTTXXX' },
          { index: 6, code: '01', name: 'ATB', swift: 'ATBKTNTTXXX' },
          { index: 7, code: '12', name: 'UIB', swift: 'IUBKPAPAXXX' },
          { index: 8, code: '05', name: 'BT', swift: 'BTBKTNTTXXX' },
          { index: 9, code: '20', name: 'BTK', swift: 'BTKOTNTT' },
          { index: 10, code: '32', name: 'Baraka', swift: 'BEITTNTTXXX' },
          { index: 11, code: '11', name: 'UBCI', swift: 'UBCITNTTXXX' },
          { index: 12, code: '25', name: 'Zitouna', swift: 'BZITTNTTXXX' },
          { index: 13, code: '47', name: 'Wifak', swift: 'WKIBTNTTXXX' },
          { index: 14, code: '26', name: 'BTL', swift: 'ATLDTNTTXXX' },
          { index: 15, code: '23', name: 'QNB', swift: 'BTQITNTT' },
          { index: 16, code: '21', name: 'TSB', swift: 'TSIDTNTT' },
          { index: 17, code: '27', name: 'BTS', swift: 'TUSOTNT1XXX' },
          { index: 18, code: '24', name: 'BTE', swift: 'BTEXTNTTXXX' },
          { index: 19, code: '28', name: 'ABC', swift: 'ABCOTNTT' },
          { index: 20, code: '17', name: 'La poste tunisienne', swift: 'LPTNTNTT' },
        ]},
    MAR:{
        LengthRIB:24,
        LengthCIN:10,
        lengthPhone:9,
        lengthCodeIBAN:3,
        CodeIBAN:'MA',
        banks:[
        { index: 0, code: '026', name: 'UMNIA BANK', swift: 'UMNIMAMMXXX' },
        { index: 1, code: '013', name: 'BMCI NAJMAH', swift: 'BMCIMAMC' },
        { index: 2, code: '023', name: 'AL BARID BANK', swift: 'ABBMMAMCXXX' },
        // { index: 3, code: '', name: 'BANK AL AMAL', swift: 'AMDHMRMRXXX' },
        // { index: 4, code: '', name: 'ATTIJARI INTERNATIONAL BANK S.A. - BANQUE OFF SHORE', swift: 'AIBSMAMT' },
        { index: 5, code: '031', name: 'CITIBANK MAGHREB', swift: 'CITIMAMCXXX' },
        // { index: 6, code: '', name: 'BANK AL-MAGRIB', swift: 'BKAMMAMRXXX' },
        { index: 7, code: '015', name: 'CREDIT DU MAROC', swift: 'CDMAMAMCXXX' },
        { index: 8, code: '025', name: 'BANK ASSAFA', swift: 'ASSFMAMCXXX' },
        { index: 9, code: '021', name: 'BANQUE MAROCAINE DU COMMERCE EXTERIEUR', swift: 'BMCEMAMC' },
        { index: 10, code: '032', name: 'CAIXABANK, S.A. SUCCURSALE AU MAROC', swift: 'CAIXMAMCXXX' },
        { index: 11, code: '011', name: 'BANQUE CENTRALE POPULAIRE', swift: 'BCPOMAMCXXX' },
        // { index: 12, code: '', name: 'ARREDA', swift: 'CDMAMAMCXXX' },
        // { index: 13, code: '', name: 'UNION MAROCAINE DE BANQUES', swift: 'UMABMAMCXXX' },
        { index: 14, code: '014', name: 'CREDIT AGRICOLE DU MAROC', swift: 'CNCAMAMRXXX' },
        { index: 15, code: '034', name: 'CDG CAPITAL', swift: 'RDGCMAMR' },
        { index: 16, code: '035', name: 'CAISSE DE DEPOT ET DE GESTION', swift: 'CDGMMAMC' },
        { index: 17, code: '007', name: 'Attijariwafa Bank', swift: 'BCMAMAMCXXX' },
        { index: 18, code: '024', name: 'CFG BANK', swift: 'CAFGMAMCCFM' },
        { index: 19, code: '027', name: 'BANK AL YOUSR', swift: 'BSYRMAMC' },
        // { index: 20, code: '', name: 'BANCO DE SABADELL, S.A.', swift: 'BSABESBBXXX' },
        { index: 21, code: '022', name: 'CREDIT IMMOBILIER ET HOTELIER', swift: 'CIHMMAMCXXX' },
        // { index: 22, code: '', name: 'BANK AL TAMWEEL WA AL INMA', swift: 'BTIMMAMC' },
        { index: 23, code: '016', name: 'SOCIETE GENERALE MAROCAINE DE BANQUES', swift: 'SGMBMAMCXXX' },
        // { index: 24, code: '', name: 'SOCIETE GENERALE OFFSHORE', swift: 'SGMBMAMC' },
        // { index: 25, code: '', name: 'DAR AL AMANE', swift: 'SGMBMAMCXXX' },
        { index: 26, code: '033', name: 'ARAB BANK PLC', swift: 'ARABMAMC' },
        { index: 27, code: '013', name: 'BANQUE MAROCAINE POUR LE COMMERCE ET L\'INDUSTRIE', swift: 'BMCIMAMCXXX' },
        { index: 28, code: '028', name: 'AL AKHDAR BANK', swift: 'AKDRMAMMXXX' },

      ]},
    SEN:{
        LengthRIB:22,
        LengthCIN:13,
        lengthPhone:9,
        CodeIBAN:'SN',
        lengthCodeIBAN:3,
        banks:[
          { index: 0, code: '000', name: "Banque Centrale des États de l'Afrique de l'Ouest (BCEAO)", swift: 'BCAOSNDAXXX' },
          { index: 1, code: '001', name: 'BCEAO Agence Kaolack', swift: 'BCAOSNDAKAO' },
          { index: 2, code: '002', name: 'BCEAO Agence Ziguinchor', swift: 'BCAOSNDAZIG' },
          { index: 3, code: '010', name: 'Banque Islamique du Sénégal (BIS)', swift: 'BISNSNDAXXX' },
          { index: 4, code: '011', name: 'Société Générale de Banques au Sénégal (SGBS)', swift: 'SGSNSNDAXXX' },
          { index: 5, code: '012', name: 'CBAO Groupe Attijariwafa Bank', swift: 'CBAOSNDAXXX' },
          { index: 6, code: '026', name: 'Citibank Dakar', swift: 'CITISNDAXXX' },
          { index: 7, code: '039', name: "Banque de l'Habitat du Sénégal (BHS)", swift: 'LHSESNDAXXX' },
          { index: 8, code: '048', name: "Crédit National de Commerce et d'Agriculture du Sénégal (CNCAS)", swift: 'CNCASNDAXXX' },
          { index: 9, code: '052', name: "Banque Sahélo-Saharienne pour l'Investissement et le Commerce (BSIC)", swift: 'BSICSNDAXXX' },
          { index: 10, code: '060', name: 'Crédit du Sénégal', swift: 'CRSNSNDAXXX' },
          { index: 11, code: '079', name: 'Banque Islamique du Sénégal (BIS)', swift: 'BISNSNDAXXX' },
          { index: 12, code: '094', name: 'Ecobank Sénégal', swift: 'ECOCSNDAXXX' },
          { index: 13, code: '100', name: 'Bank of Africa - Sénégal (BOA)', swift: 'AFRISNDAXXX' },
          { index: 14, code: '111', name: "Banque Sahélo-Saharienne pour l'Investissement et le Commerce (BSIC)", swift: 'BSICSNDAXXX' },
          { index: 15, code: '117', name: "Banque des Institutions Mutualistes d'Afrique de l'Ouest (BIMAO)", swift: 'BIMASNDAXXX' },
          { index: 16, code: '125', name: 'Banque Régionale de Solidarité (BRS)', swift: 'BRSNSNDAXXX' },
          { index: 17, code: '137', name: 'Banque Atlantique Sénégal', swift: 'ATSNSNDAXXX' },
          { index: 18, code: '140', name: 'International Commercial Bank (ICB) Sénégal', swift: 'ICBKSNDAXXX' },
          { index: 19, code: '141', name: 'Citigroup', swift: 'CITISNDAXXX' },
          { index: 20, code: '144', name: 'Banque Régionale des Marchés (BRM)', swift: 'BRMSNDAXXX' },
          { index: 21, code: '153', name: 'United Bank for Africa (UBA) Sénégal', swift: 'UNAFSNDAXXX' },
          { index: 22, code: '156', name: 'Crédit International', swift: 'CRINSNDAXXX' },
          { index: 23, code: '159', name: 'Diamond Bank Sénégal', swift: 'DBLNSNDAXXX' },
          { index: 24, code: '169', name: 'Banque Nationale pour le Développement Économique (BNDE)', swift: 'BNDESNDAXXX' },
          { index: 25, code: '175', name: 'Orabank Sénégal', swift: 'ORBKSNDAXXX' },
          { index: 26, code: '178', name: 'Banque Commerciale Internationale (BCI) Sénégal', swift: 'BCIKSNDAXXX' },
          { index: 27, code: '189', name: 'BGFIBank Sénégal', swift: 'BGFISNDAXXX' },
          { index: 28, code: '191', name: 'Banque de Dakar (BDK)', swift: 'BDKRSNDAXXX' },
          { index: 29, code: '197', name: 'Coris Bank International Sénégal', swift: 'CORISNDAXXX' },
          { index: 30, code: '200', name: 'Banque Outarde du Sénégal', swift: 'OUTASNDAXXX' },
          { index: 31, code: '213', name: 'Coris Bank International Sénégal', swift: 'CORISNDAXXX' },
    
         ]},
    TUR:{
        LengthRIB:24,
        LengthCIN:11,
        lengthPhone:10,
        lengthCodeIBAN:5,
        CodeIBAN:'TR',
        banks:[
            { index: 0, code: '00123', name: 'HSBC BANK A.S.', swift: 'HSBCTRIX' },
            { index: 1, code: '00032', name: 'T.EKONOMİ BANKASI A.S.', swift: 'TEBUTRIS' },
            { index: 2, code: '00111', name: 'FINANSBANK A.S.', swift: 'FNNBTRIS' },
            { index: 3, code: '00012', name: 'HALK BANKASI', swift: 'TRHBTR2A' },
            { index: 4, code: '00064', name: 'T.IŞ BANKASI A.S.', swift: 'ISBKTRIS' },
            { index: 5, code: '00046', name: 'AKBANK T.A.S.', swift: 'AKBKTRIS' },
            { index: 6, code: '00010', name: 'TC ZIRAAT BANKASI', swift: 'TCZBTR2A' },
            { index: 7, code: '00015', name: 'T.VAKIFLAR BANKASI T.A.O.', swift: 'TVBATR2A' },
            { index: 8, code: '00062', name: 'T.GARANTİ BANKASI A.S.', swift: 'TGBATRIS' },
            { index: 9, code: '00124', name: 'BURGAN BANK A.S.', swift: 'TEKFTRIS' }
]},

    PAK:{
        LengthRIB:26,
        LengthCIN:13,
        lengthPhone:10,
        lengthCodeIBAN:4,
        CodeIBAN:'PK',
        banks:[
          { index: 0, code: '0009', name: 'Faysal Bank Limited', swift: 'FAYSPKKA' },
          { index: 1, code: '0023', name: 'ALBARAKA', swift: 'AIINPKKA' },
          { index: 2, code: '0013', name: 'Bank Islami Pakistan Limited', swift:'BKIPPKKA'},
          { index: 3, code: '0004', name: 'MCB Bank Limited', swift: 'MUCBPKKA' },
          { index: 4, code: '0008', name: 'Meezan Bank', swift: 'MEZNPKKA' },
          { index: 5, code: '0012', name: 'Sindh Bank', swift: 'SINDPKKA' },
          { index: 6, code: '0026', name: 'ICBC Pakistan', swift: 'ICBKPKKA' },
          { index: 7, code: '0010', name: 'Soneri Bank Limited', swift: 'SONEPKKA' },
          { index: 8, code: '0009', name: 'FAYSAL', swift: 'FAYSPKKA' },
          { index: 9, code: '0005', name: 'Allied Bank Limited', swift: 'ABPAPKKA' },
          { index: 10, code: '0014', name: 'Dubai Islamic Bank', swift: 'DUIBPKKA' },
          { index: 11, code: '0015', name: 'Silk Bank', swift: 'SAUDPKKA' },
          { index: 12, code: '0017', name: 'Bank of Punjab', swift: 'BPUNPKKA' },
          { index: 13, code: '0029', name: 'First Women Bank Limited', swift: 'FWBLPKKA' },
          { index: 14, code: '0030', name: 'Habib Metropolitan Bank', swift: 'MPBLPKKA' },
          { index: 15, code: '0003', name: 'National Bank of Pakistan', swift: 'NBPAPKKA' },
          { index: 16, code: '0006', name: 'Askari Bank', swift: 'ASCMPKKA' },
          { index: 17, code: '0001', name: 'Habib Bank Limited', swift: 'HABBPKKA' },
          { index: 18, code: '0011', name: 'JS Bank', swift: 'JSBLPKKA' },
          { index: 19, code: '0016', name: 'Summit Bank Limited', swift: 'SMTINGLA' },
          { index: 20, code: '0024', name: 'Standard Chartered Bank Pakistan', swift: 'SCBLPKKA' },
          { index: 21, code: '0025', name: 'CitiBank', swift: 'CITIPKKA' },
          { index: 22, code: '0007', name: 'Bank Alfalah', swift: 'ALFHPKKA' },

]},

    NGA:{
        LengthRIB:10,
        LengthCIN:11,
        lengthPhone:10,
        lengthCodeIBAN:3,
        CodeIBAN:'',
        banks:[
          { index: 0, code: '044', name: 'Access Bank PLC', swift: 'ABNGNGLA' },
          { index: 1, code: '100', name: 'Suntrust Bank', swift: 'SUTNNGLA' },
          { index: 2, code: '030', name: 'Heritage Bank PLC', swift: 'HBCLNGLA' },
          { index: 3, code: '076', name: 'Polaris Bank PLC', swift: 'PRDTNGLA' },
          { index: 4, code: '232', name: 'Sterling Bank PLC', swift: 'NAMENGLA' },
          { index: 5, code: '070', name: 'Fidelity Bank PLC', swift: 'FIDTNGLA' },
          { index: 6, code: '058', name: 'Guaranty Trust Bank (GTBank)', swift: 'GTBINGLA' },
          { index: 7, code: '301', name: 'Jaiz Bank', swift: 'JAIZNGLA' },
          { index: 8, code: '011', name: 'First Bank Of Nigeria PLC', swift: 'FBNINGLA' },
          { index: 9, code: '082', name: 'Keystone Bank PLC', swift: 'PLNINGLA' },
          { index: 10, code: '035', name: 'Wema Bank PLC', swift: 'WEMANGLA' },
          { index: 11, code: '050', name: 'Ecobank Nigeria PLC', swift: 'ECOCNGLA' },
          { index: 12, code: '032', name: 'Union Bank Of Nigeria PLC', swift: 'UBNINGLA' },
          { index: 13, code: '215', name: 'Unity Bank PLC', swift: 'ICITNGLA' },
          { index: 14, code: '221', name: 'Stanbic IBTC Bank PLC', swift: 'SBICNGLX' },
          { index: 15, code: '033', name: 'United Bank For Africa PLC', swift: 'UNAFNGLA' },
          { index: 16, code: '068', name: 'Standard Chartered Bank PLC', swift: 'SCBLNGLA' },
          { index: 17, code: '023', name: 'CITI Bank', swift: 'CITINGLA' },
          { index: 18, code: '101', name: 'Providus Bank', swift: 'UMPLNGLA' },
          { index: 19, code: '057', name: 'Zenith International Bank PLC', swift: 'ZEIBNGLA' },
          { index: 20, code: '214', name: 'First City Monument Bank PLC', swift: 'FCMBNGLA' },



        ]},

    KEN:{
        LengthRIB:22,
        LengthCIN:8,
        lengthPhone:9,
        lengthCodeIBAN:2,
        CodeIBAN:'KE',
        banks:[
          { index: 0, code: '74', name: 'First Community Bank', swift: 'IFCBKENA' },
          { index: 1, code: '01', name: 'Central Bank of Kenya', swift: 'CBKEKENA' },
          { index: 2, code: '12', name: 'National Bank of Kenya Limited', swift: 'NBKEKENX' },
          { index: 3, code: '02', name: 'Standard Chartered Bank Kenya Limited', swift: 'SCBLKENX' },
          { index: 4, code: '54', name: 'Victoria Commercial Bank Limited', swift: 'VICMKENA' },
          { index: 5, code: '16', name: 'Citibank N A', swift: 'CITIKENA' },
          { index: 6, code: '03', name: 'ABSA Bank', swift: 'BARCKENX' },
          { index: 7, code: '14', name: 'Middle East Bank Kenya Limited', swift: 'MIEKKENA' },
          { index: 8, code: '53', name: 'Guaranty Trust Bank ( Kenya) Ltd.', swift: 'GTBIKENA' },
          { index: 9, code: '63', name: 'Diamond Trust Bank Limited', swift: 'DTKEKENA' },
          { index: 10, code: '72', name: 'Gulf African Bank Ltd', swift: 'GAFRKENA' },
          { index: 11, code: '48', name: 'Spire Bank Ltd', swift: 'SPBLKENA' },
          { index: 12, code: '11', name: 'Co-operative Bank of Kenya Limited', swift: 'KCOOKENA' },
          { index: 13, code: '23', name: 'Consolidated Bank of Kenya Limited', swift: 'CONKKENA' },
          { index: 14, code: '31', name: 'Stanbic Bank Kenya Limited', swift: 'SBICKENX' },
          { index: 15, code: '68', name: 'Equity Bank Limited', swift: 'EQBLKENA' },
          { index: 16, code: '76', name: 'UBA Kenya Bank Ltd', swift: 'UNAFKENA' },
          { index: 17, code: '04', name: 'Bank of Baroda (Kenya Limited)', swift: 'BARBKENA' },
          { index: 18, code: '43', name: 'M-Oriental Bank Limited', swift: 'MORBKENA' },
          { index: 19, code: '19', name: 'Dubai Bank Kenya Limited', swift: 'DUKNKENA' },
          { index: 20, code: '55', name: 'African Banking Corp. Bank Ltd', swift: 'ABCLKENA' },
          { index: 21, code: '43', name: 'ECO Bank Limited', swift: 'ECOCKENA' },
          { index: 22, code: '01', name: 'Kenya Commercial Bank Limited', swift: 'KCBLKENX' },
          { index: 23, code: '50', name: 'Paramount Universal Bank Limited', swift: 'PAUTKENA' },
          { index: 24, code: '70', name: 'Family Bank Ltd', swift: 'FABLKENA' },
          { index: 25, code: '10', name: 'Prime Bank Limited', swift: 'PRIEKENX' },
          { index: 26, code: '43', name: 'NIC Bank Limited', swift: 'NINCKENA' },
          { index: 27, code: '61', name: 'Housing Finance Bank', swift: 'HFCOKENA' },
          { index: 28, code: '57', name: 'KENYA WOMEN MICROFINANCE BANK LT', swift: 'KWMIKENX' },
          { index: 29, code: '59', name: 'Bank of India', swift: 'BKIDKENA' },
          { index: 30, code: '66', name: 'Sidian Bank Limited', swift: 'SIDNKENA' },
          { index: 31, code: '07', name: 'Jamii Bora Bank', swift: 'CIFIKENA' },
          { index: 32, code: '08', name: 'Habib Bank A G Zurich', swift: 'HBZUKENA' },
          { index: 33, code: '25', name: 'Credit Bank Limited', swift: 'CRBTKENX' },
          { index: 34, code: '07', name: 'NCBA Bank Kenya', swift: 'CBAFKENX' },
          { index: 35, code: '57', name: 'Imperial Bank Limited', swift: 'IMPLKENA' },
          { index: 36, code: '55', name: 'Guardian Bank Limited', swift: 'GUARKENA' },
          { index: 37, code: '18', name: 'Habib Bank Limited', swift: 'HBZUKENA' },
          { index: 38, code: '35', name: 'Bank of Africa Kenya Limited', swift: 'AFRIKENX' },
          { index: 39, code: '42', name: 'Giro Commercial Bank Limited', swift: 'GIROKENX' },
          { index: 40, code: '72', name: 'DIB Bank Kenya Limited', swift: 'DUIBKENA' },
          { index: 41, code: '26', name: 'Trans-National Bank Limited', swift: 'TNBLKENA' },
          { index: 42, code: '60', name: 'SBM Bank Ltd.', swift: 'SBMKKENA' },
          { index: 43, code: '57', name: 'I&M Bank Limited', swift: 'IMBLKENA' },
          { index: 44, code: '20', name: 'Development Bank of Kenya Limited', swift: 'DEVKKENA' },
        ]},
        
    PHL:{
        LengthRIB:{ min: 10, max: 16 },
        LengthCIN:12,
        lengthPhone:10,
        lengthCodeIBAN:9,
        CodeIBAN:'',
        banks:[
          { index: 0, code: '010530667', name: 'Land Bank of the Philippines', swift: 'TLBPPHMM' }, 
          { index: 1, code: '010040018', name: 'Bank of the Philippine Islands (BPI)', swift: 'BOPIPHMM' }, 
          { index: 2, code: '010080010', name: 'Metropolitan Bank and Trust Company (Metrobank)', swift: 'MBTCPHMM' }, 
          { index: 3, code: '010060014', name: 'Philippine National Bank (PNB)', swift: 'PNBMPHMM' }, { index: 4, code: '010280017', name: 'Security Bank Corporation', swift: 'SETCPHMM' }, 
          { index: 5, code: '010620017', name: 'Union Bank of the Philippines', swift: 'UBPHPHMM' }, 
          { index: 6, code: '010070017', name: 'China Banking Corporation', swift: 'CHBKPHMM' }, 
          { index: 7, code: '010100013', name: 'Rizal Commercial Banking Corporation (RCBC)', swift: 'RCBCPHMM' }, 
          { index: 8, code: '010050011', name: 'Development Bank of the Philippines (DBP)', swift: 'DBPHPHMM' }, 
          { index: 9, code: '010590018', name: 'EastWest Bank', swift: 'EWBCPHMM' }, 
          { index: 10, code: '010260010', name: 'Philippine Bank of Communications (PBCom)', swift: 'CPHIPHMM' }, 
          { index: 11, code: '010110016', name: 'United Coconut Planters Bank (UCPB)', swift: 'UCPBPHMM' }, 
          { index: 12, code: '010340015', name: 'Asia United Bank', swift: 'AUBKPHMM' }, 
          { index: 13, code: '010140015', name: 'Maybank Philippines', swift: 'MBBEPHMM' }, 
          { index: 14, code: '010390016', name: 'CTBC Bank Philippines', swift: 'CTCBPHMM' }, 
          { index: 15, code: '010320013', name: 'Sterling Bank of Asia', swift: 'STLAPH22' }, 
          { index: 16, code: '010170015', name: 'Robinsons Bank', swift: 'ROBPPHMQ' }, 
          { index: 17, code: '010270013', name: 'Bank of Commerce', swift: 'PABIPHMM' }, 
          { index: 18, code: '010200010', name: 'Standard Chartered Bank Philippines', swift: 'SCBLPHMM' }, 
          { index: 19, code: '010210013', name: 'HSBC Philippines', swift: 'HSBCPHMM' }, 
          { index: 20, code: '010220016', name: 'Citibank Philippines', swift: 'CITIPHMX' }, 
          { index: 21, code: '010300015', name: 'Deutsche Bank Philippines', swift: 'DEUTPHMM' }, 
          { index: 22, code: '010240012', name: 'JP Morgan Chase Bank Manila', swift: 'CHASPHMM' }, 
          { index: 23, code: '010310018', name: 'Bank of China Manila Branch', swift: 'BKCHPHMM' }, 
          { index: 24, code: '010650013', name: 'CIMB Bank Philippines', swift: 'CIPHPHMM' }, 
          { index: 25, code: '010660016', name: 'Tonik Digital Bank', swift: 'TODGPHM2' }, 
          { index: 26, code: '010670019', name: 'GoTyme Bank', swift: 'GOTYPHM2' }, 
          { index: 27, code: '010680012', name: 'Maya Bank', swift: 'MYYAPHM2' }, 
          { index: 28, code: '010690015', name: 'UNO Digital Bank', swift: 'UNOBPHM2' } 

        ]},

    BGD:{
        lengthPhone:10,
        },
    


    

    
 
}

